import { LazyPage, PipelineSourceLayoutPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineSourceLayoutRoute() {
  return (
    <LazyPage>
      <PipelineSourceLayoutPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId')({
  component: PipelineSourceLayoutRoute,
});
